module.exports = __webpack_public_path__ + "img/40_38_071_830.1a5f07b5.jpg";